module.exports = __webpack_public_path__ + "img/youmai-bg.65750eb4.jpg";